import AButtonCopy from './a-button-copy.vue';

export default AButtonCopy;
